import Vue from 'vue';

export const BIZAI_EVENTS = {
  CHAT_OPENED: 'BizAI Chat Opened',
  CHAT_CLOSED: 'BizAI Chat Closed',
  MESSAGE_SENT: 'BizAI Message Sent',
  STARTER_TAPPED: 'BizAI Starter Tapped',
  TOPIC_STARTED: 'BizAI Topic Started',
  ENTITY_CARD_TAPPED: 'BizAI Entity Card Tapped',
  ENTITY_ACTION_TAPPED: 'BizAI Entity Action Tapped',
  ERROR_SHOWN: 'BizAI Error Shown',
  RESPONSE_STOPPED: 'BizAI Response Stopped',
  FLOW_CONFIRMED: 'BizAI Flow Confirmed',
  RESET_CHAT: 'Reset chat',
  MODAL_OPENED: 'BizAI Modal Opened',
  MODAL_CLOSED: 'BizAI Modal Closed',
};

export const MODAL_RESULTS = {
  DONE: 'done',
  CANCELLED: 'cancelled',
};

export const trackModalOpened = (modalName) => {
  Vue.prototype.$track?.(BIZAI_EVENTS.MODAL_OPENED, { modal_name: modalName });
};

export const trackModalClosed = (modalName, result) => {
  Vue.prototype.$track?.(BIZAI_EVENTS.MODAL_CLOSED, { modal_name: modalName, result });
};

export const MESSAGE_TRIGGERS = {
  INPUT: 'input',
  STARTER: 'starter',
  RADIO_SELECTION: 'radio_selection',
  ENTITY_CARD: 'entity_card',
  RETRY: 'retry',
  RECOMMENDATION: 'recommendation',
  WORKFLOW_LAUNCH: 'workflow_launch',
};

export const trackMessageSent = (props = {}) => {
  Vue.prototype.$track?.(BIZAI_EVENTS.MESSAGE_SENT, props);
};

export const STOP_STATES = {
  BEFORE_RESPONSE: 'before_response',
  DURING_STREAMING: 'during_streaming',
};

export const CTA_VALUES = {
  CONFIRMED: 'confirmed',
  CANCELED: 'canceled',
};

export const resolveStopState = (aiMessageText) => (
  aiMessageText ? STOP_STATES.DURING_STREAMING : STOP_STATES.BEFORE_RESPONSE
);

export const buildFlowConfirmedProps = (confirmed, actionType) => ({
  cta: confirmed ? CTA_VALUES.CONFIRMED : CTA_VALUES.CANCELED,
  ...(actionType ? { action_type: actionType } : {}),
});

export const msToSec = (ms) => Math.round(ms / 1000);

export const classifyErrorType = (message) => {
  if (!message) return 'other';
  const m = String(message).toLowerCase();
  if (m.includes('network') || m.includes('connection')) return 'network';
  if (m.includes('timeout') || m.includes('timed out')) return 'timeout';
  if (m.includes('something went wrong')) return 'ai_failure';
  return 'other';
};
